module.exports = __webpack_public_path__ + "static/media/bell.20d3a4ee.svg";